import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import { useInView } from '../hooks/useInView';
const faqs = [{
  question: '¿Es legal tener esta guía?',
  answer: 'Absolutamente. Esta guía contiene información de derechos constitucionales que aplican a todas las personas en Estados Unidos, sin importar su estatus migratorio. Conocer tus derechos es completamente legal y necesario.'
}, {
  question: '¿En qué formato viene?',
  answer: 'La guía viene en formato PDF digital de alta calidad que puedes leer en tu teléfono, tablet o computadora. La recibes en tu correo electrónico inmediatamente después de tu compra.'
}, {
  question: '¿La información está actualizada?',
  answer: 'Sí. Esta edición 2026 incluye los cambios más recientes en políticas migratorias y recursos legales disponibles. Nos aseguramos de mantener el contenido vigente.'
}, {
  question: '¿Qué pasa si no me sirve?',
  answer: 'Ofrecemos una garantía de devolución de 7 días. Si sientes que la guía no te aporta valor, escríbenos y te devolvemos tu dinero sin preguntas.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const [headerRef, headerInView] = useInView();
  const [listRef, listInView] = useInView();
  return <section className="py-16 bg-[#1a56a0] text-white border-t border-white/10" data-id="element-35">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-36">
        <div ref={headerRef} className={`text-center mb-12 animate-on-scroll ${headerInView ? 'in-view' : ''}`} data-id="element-37">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-4 uppercase tracking-wide" data-id="element-38">
            Preguntas Frecuentes
          </h2>
          <div className="w-24 h-1 bg-[#c0392b] mx-auto" data-id="element-39" />
        </div>

        <div ref={listRef} className="space-y-4" data-id="element-40">
          {faqs.map((faq, index) => <div key={index} className={`border ${openIndex === index ? 'border-[#c0392b] bg-[#1e5fad]' : 'border-white/10 bg-transparent'} transition-colors duration-300 animate-on-scroll delay-${index * 2} ${listInView ? 'in-view' : ''}`} data-id="element-41">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="flex items-center justify-between w-full p-6 text-left focus:outline-none" data-id="element-42">
                <span className={`font-sans font-bold text-lg md:text-xl ${openIndex === index ? 'text-white' : 'text-white/75'}`} data-id="element-43">
                  {faq.question}
                </span>
                <span className={`ml-4 flex-shrink-0 ${openIndex === index ? 'text-[#c0392b]' : 'text-white/50'}`} data-id="element-44">
                  {openIndex === index ? <Minus className="w-6 h-6" data-id="element-45" /> : <Plus className="w-6 h-6" data-id="element-46" />}
                </span>
              </button>

              <div className={`faq-content ${openIndex === index ? 'open' : ''}`} data-id="element-47">
                <div className="faq-inner" data-id="element-48">
                  <div className="p-6 pt-0 text-white/80 font-sans leading-relaxed border-t border-white/5 mt-2" data-id="element-49">
                    {faq.answer}
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}